import React from "react";
import { CheckCircle } from "lucide-react";
import { JUST_ASK_VI_URL } from "./Hero";

const Pricing = () => {
  return (
    <section className="bg-[#ffffff] py-16 md:py-24">
      <div className="max-w-[64rem] mx-auto px-4">
        <h2 className="text-center text-3xl font-semibold mb-8">Pricing</h2>

        <div className="bg-white p-8 rounded-lg shadow-md flex flex-col border border-gray-200 max-w-md mx-auto">
          <h3 className="text-xl font-semibold mb-2 text-center">Pay per company</h3>
          <p className="text-center text-3xl font-bold text-gray-800 mb-1">₹600 <span className="text-base font-normal text-gray-600">+ 18% GST</span></p>
          <p className="text-center text-gray-600 mb-6">₹708 per company, all inclusive</p>
          <ul className="space-y-5">
            <li className="flex items-start">
              <CheckCircle className="text-green-600 mr-2 flex-shrink-0" />
              <span>P&L, BS, CF Statements in excel format</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="text-green-600 mr-2 flex-shrink-0" />
              <span>Annual reports</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="text-green-600 mr-2 flex-shrink-0" />
              <span>GST invoice emailed after payment</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="text-green-600 mr-2 flex-shrink-0" />
              <span>No subscription, buy only what you need</span>
            </li>
          </ul>

          <div className="border-t border-gray-200 my-6 w-1/2 mx-auto"></div>

          <div className="flex justify-center">
            <a
              href={JUST_ASK_VI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-600 text-white px-6 py-2 rounded text-center hover:bg-yellow-700 transition-colors"
            >
              Try Just Ask VI
            </a>
          </div>
        </div>

        <p className="text-center text-gray-600 mt-10">
          Need financials for many companies on an ongoing basis? See the{" "}
          <a href="/products/cfs" className="text-[#c59c40] hover:text-[#a07924] hover:underline">
            Company Financials Search (CFS) Database
          </a>
          .
        </p>
      </div>
    </section>
  );
};

export default Pricing;
